export const recargaOkiConstants = {
  LIST_OKI_REQUEST: 'LIST_OKI_REQUEST',
  LIST_OKI_SUCCESS: 'LIST_OKI_SUCCESS',
  LIST_OKI_FAILURE: 'LIST_OKI_FAILURE'
};
